import "bootstrap/dist/css/bootstrap.min.css"
import { createApp } from "vue";
import App from "./App.vue";
import titleMixin from './mixins/titleMixin'

const app = createApp(App);
app.mixin(titleMixin);
app.use(router).mount("#app");

import "bootstrap/dist/js/bootstrap.js"
import router from './router'